import React, { useEffect, useMemo, useRef, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { themeButtons } from '../../css/themeButtons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Field, Form, Formik, useFormikContext } from 'formik';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { AccordionDetailStyled, AccordionStyled } from './styles';
import Preloader from '../common/Preloader/Preloader';
import { usePrevious } from '../common/CustomHook/usePrevious';
import Modal from '../common/Modals/Modal';
import DateRangePickerComponent from '../common/DateRangePickerComponent/DateRangePickerComponent';
import { chunk } from 'lodash';
import { isWithinInterval } from 'date-fns';
import AutoSaveWithDebounce from '../common/Autosave/AutoSaveWithDebounce';
import StickyBottomButton from '../common/StickyBottomButtonSave/StickyBottomButton';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import AlertSavePage from '../common/AlertSavePage/AlertSavePage';
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { ChangeDirtyForm } from '../common/CustomHook/ChangeDirtyFrom';

//Рендер вехней части страницы с инструкцие и местом по доп кнопки
const RenderSettingsMenu = () => {
  const [showInstruction, setShowInstruction] = useState(false);
  const toggleShowInstruction = () => {
    setShowInstruction(!showInstruction);
  };

  return (
    <div id='settings-menu'>
      <div className='container-fluid'>
        <div className='d-flex flex-wrap'>
          <Box className='instruction' onClick={toggleShowInstruction}>
            <span className='instruction__text'>Инструкция</span>
            <IconButton>
              <FontAwesomeIcon icon={['far', 'question-circle']}/>
            </IconButton>
          </Box>
        </div>
      </div>
      <Modal
        toggleShow={toggleShowInstruction}
        show={showInstruction}
        title={'Инструкция:'}
        textBtnOk={'Понятно'}
      >
        <Typography variant='body1' gutterBottom>
          <b>1. Добавление периода.</b> Нажмите на кнопку "Добавить период".
          Выберите даты начала и окончания периода и нажмите кнопку "Добавить";
        </Typography>
        <Typography variant='body1' gutterBottom>
          <b>2. Редактирование цены.</b> Введите нужную сумму на пересечении
          строки периода и колонки типа размещения, после нажмите кнопку
          сохранить в нижней части экрана. Так же Вы можете редактировать цены
          сразу в нескольких ячейках и сохранять их все вместе;
        </Typography>
        <Typography variant='body1' gutterBottom>
          <b>3. Изменение типа цены.</b> Нажмите на кнопку "Тип цены", которая
          находится рядом с названием номера, в выпадающем списке выберите тип
          цены номер.
          <b>
            Обратите внимание. Таблица будет изменена и цены надо будет ввести
            заново
          </b>
          ;
        </Typography>
        <Typography variant='body1' gutterBottom>
          <b>4. Добавление типа размещения.</b> Нажмите кнопку добавить в самой
          правой колонке таблицы, выберите тип размещения в выпадающем списке и
          нажмите, тип размещения будет добавлен в таблицу;
        </Typography>
        <Typography variant='body1' gutterBottom>
          <b>5. Удаление типа размещения.</b> Нажмите кнопку с типом размещения,
          находящуюся в самой верхней строке таблицы цены номера. В выпадающем
          списке выберите "Удалить столбец";
        </Typography>
      </Modal>
    </div>
  );
};

const RenderDropdownInHeader = ({
  col,
  addTypeOfAllocation,
  addCol,
  personesCountLineOver,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const { values } = useFormikContext();

  const handleClose = (type, col) => {
    setAnchorEl(null);
    if (type) {
      addTypeOfAllocation(values, type, col);
    }
  };

  const dropdownBtnText = (type) => {
    switch (type) {
      case 'child': {
        return 'Детское место';
        break;
      }
      case 'additional': {
        return 'Доп. место';
        break;
      }
      case '1': {
        return `${type} гость`;
        break;
      }
      default: {
        return `До ${type} гостей`;
        break;
      }
    }
  };

  return (
    <div className='room-calendar__table-col add-price'>
      <Button className='btn' onClick={handleClick}>
        {addCol ? (
          <>
            <FontAwesomeIcon icon={['fas', 'plus']} className='me-1'/> Добавить
          </>
        ) : (
          <>
            <FontAwesomeIcon icon={['far', 'edit']} className='me-1'/>{' '}
            {dropdownBtnText(col)}
          </>
        )}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
      >
        {personesCountLineOver &&
          personesCountLineOver.map((item) => {
            return (
              <MenuItem key={item} onClick={() => handleClose('add', item)}>
                {dropdownBtnText(item)}
              </MenuItem>
            );
          })}

        {!addCol && (
          <MenuItem onClick={() => handleClose('delete', col)}>
            Удалить столбец
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

//Шапка в таблице цен номера
const RenderPeriodTableHeader = React.memo(
  ({
    mobile,
    personesCountLine,
    personesCountLineOver,
    addTypeOfAllocation,
  }) => {
    return (
      <>
        <div className='room-calendar__table-period room-calendar__table-period_hidden'>
          Периоды
        </div>
        <div
          className='row g-2'
          style={{ flexGrow: 1, flexShrink: 0, alignItems: 'center' }}
        >
          {personesCountLine &&
            personesCountLine.map((col, index) => (
              <div className='col' key={Math.random()}>
                {index === 0 ? (
                  <div className='room-calendar__table-col'>
                    {col != 1 ? `До ${col} гостей` : `${col} гость`}
                  </div>
                ) : (
                  <RenderDropdownInHeader
                    col={col}
                    addTypeOfAllocation={addTypeOfAllocation}
                    personesCountLineOver={personesCountLineOver}
                  />
                )}
              </div>
            ))}

          {personesCountLineOver && personesCountLineOver.length !== 0 && (
            <div className='col'>
              <RenderDropdownInHeader
                addTypeOfAllocation={addTypeOfAllocation}
                addCol={true}
                personesCountLineOver={personesCountLineOver}
              />
            </div>
          )}
        </div>
      </>
    );
  }
);

//строка таблицы (период)
const RenderPeriodTableRow = React.memo(
  ({
    date,
    dateFrom,
    dateTo,
    personesCountLineOver,
    deletePeriodConfirm,
    changePeriod,
  }) => {
    const { values } = useFormikContext();

    const fields = useMemo(() => {
      return values && Object.keys(values)
        .filter((item) => item.split('|')[0] === date)
        .sort((a, b) => {
          let aFormate = Number(a.split('|')[1])
            ? parseInt(a.split('|')[1])
            : a.split('|')[1];
          let bFormate = Number(b.split('|')[1])
            ? parseInt(b.split('|')[1])
            : b.split('|')[1];

          if (Number.isInteger(aFormate) && Number.isInteger(bFormate))
            return aFormate < bFormate ? 1 : -1;
          if (Number.isInteger(aFormate)) return -1;
          if (Number.isInteger(bFormate)) return 1;
          if (bFormate === 'additional') return -1;
          if (aFormate === 'child') return 1;
          return 0;
        })
        .map((item, index) => {
          return (
            <div key={item} className='col'>
              <Field name={`${item}`}>
                {({ field, form }) => (
                  <FormControl
                    className='room-calendar__table-col form-control'
                    variant='outlined'
                    size='small'
                  >
                    <OutlinedInput
                      {...field}
                      type='number'
                      placeholder='Цена'
                      endAdornment={
                        <InputAdornment position='end'>₽</InputAdornment>
                      }
                    />
                  </FormControl>
                )}
              </Field>
            </div>
          );
        })
    }, [date, values])

    return (
      <div className='room-calendar__row'>
        <div className='room-calendar__table-period'>
          <div className='room-calendar__table-period-text'>
            {`${dateFrom} - ${dateTo}`}
          </div>
          <div className='room-calendar__table-period-change'>
            <Button
              onClick={() => changePeriod(date)}
              className='btn btn-light'
            >
              <FontAwesomeIcon icon={['far', 'edit']}/>
              Изменить
            </Button>
            <IconButton
              onClick={() => deletePeriodConfirm(date)}
              className='p-2'
            >
              <DeleteIcon fontSize='small'/>
            </IconButton>
          </div>
        </div>
        <div className='row g-2' style={{ flexGrow: 1, flexShrink: 0 }}>
          {fields}
          {personesCountLineOver && personesCountLineOver.length !== 0 && (
            <div className='col'>
              <FormControl
                className='room-calendar__table-col'
                variant='outlined'
                size='small'
              >
                <OutlinedInput
                  disabled
                  type='number'
                  endAdornment={
                    <InputAdornment position='end'>₽</InputAdornment>
                  }
                />
              </FormControl>
            </div>
          )}
        </div>
      </div>
    );
  }
);

//модалка удаления периода
const ModalDeletePeriod = ({ toggleShow, show, action, period }) => {
  let dateRange = [];
  if (period) {
    period.split('/').forEach((date) => {
      dateRange.push(date.split('-').reverse().join('.').slice(0, 5));
    });
  }

  return (
    <Modal
      toggleShow={toggleShow}
      btnOkAction={action}
      show={show}
      title={'Удалить период:'}
      textBtnOk={'Удалить'}
    >
      <h6>
        {dateRange.length !== 0 &&
          `Период с ${dateRange[0]} по ${dateRange[1]}`}
      </h6>
    </Modal>
  );
};

//модалка добавления периода
const ModalAddPeriod = ({ toggleShow, show, action, lastDateTable }) => {
  const { values } = useFormikContext();
  let prices = values;

  let minDate = new Date(new Date().getFullYear(), 0, 1);
  let maxDate = new Date(new Date().getFullYear(), 11, 31);

  const period = useMemo(() => {
    if (!lastDateTable || (new Date(lastDateTable).getMonth() === 11)) return [minDate, new Date(new Date().getFullYear(), 0, 2)];

    return [
      new Date(lastDateTable).setDate(new Date(lastDateTable).getDate() + 1),
      new Date(lastDateTable).setDate(new Date(lastDateTable).getDate() + 2),
    ];
  }, [lastDateTable, minDate])


  return (
    <Formik
      initialValues={{ period }}
      enableReinitialize
    >
      {({ isValid, values, setFieldError, errors, setErrors }) => {
        const onSubmit = () => {
          if (isValid) {
            action(values.period, prices);
          }
        };

        return (
          <Modal
            toggleShow={toggleShow}
            btnOkAction={onSubmit}
            show={show}
            title={'Добавить период:'}
            textBtnOk={'Добавить'}
          >
            <Form>
              <DateRangePickerComponent
                onError={(reason) => {
                  reason[0] || reason[1]
                    ? setFieldError('period', 'Некорректные даты')
                    : setErrors({});
                }}
                name='period'
                startText='Начало периода'
                endText='Конец периода'
                toolbarTitle='Период от/до'
                inputFormat={'dd.MM'}
                mask={'__.__'}
                error={Boolean(errors.period)}
                helperText={errors.period}
                minDate={minDate}
                maxDate={maxDate}
                className='datepicker-subscriber'
              />
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );
};

//модалка редактирования периода
const ModalChangePeriod = ({ toggleShow, show, action, changedPeriod }) => {
  const { values } = useFormikContext();
  let prices = values;

  const period = useMemo(() => {
    return changedPeriod ? [changedPeriod.split('/')[0], changedPeriod.split('/')[1]] : [null, null];
  }, [changedPeriod])

  return (
    <Formik
      initialValues={{ period }}
      enableReinitialize
    >
      {({ values, isValid, errors, setFieldError, setErrors }) => {
        const onSubmit = () => {
          if (isValid) {
            action(values.period, prices);
          }
        };

        return (
          <Modal
            toggleShow={toggleShow}
            btnOkAction={onSubmit}
            show={show}
            title={'Изменить период:'}
            textBtnOk={'Применить'}
            disableEnforceFocus
          >
            <Form>
              <DateRangePickerComponent
                onError={(reason) => {
                  reason[0] || reason[1]
                    ? setFieldError('period', 'Некорректные даты')
                    : setErrors({});
                }}
                name='period'
                startText='Начало периода'
                endText='Конец периода'
                inputFormat={'dd.MM'}
                mask={'__.__'}
                error={Boolean(errors.period)}
                helperText={errors.period}
                minDate={new Date(new Date().getFullYear(), 0, 1)}
                maxDate={new Date(new Date().getFullYear(), 11, 31)}
                className='datepicker-subscriber'
              />
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );
};

//рендер таблицы цен по номеру
export const RenderPriceTableSubscriber = React.memo((props) => {
  const {
    prices,
    maxType,
    id,
    presavedPrice,
    toggleUnsavedPage,
    priceType,
    goBackToInitialState,
  } = props;

  const [roomPrice, setRoomPrice] = useState();
  const [initialValues, setInitialValues] = useState();
  const [personesCountLine, setPersonesCountLine] = useState();
  const [personesCountLineOver, setPersonesCountLineOver] = useState();
  const [deletedPeriod, setDeletedPeriod] = useState();
  const [changedPeriod, setChangedPeriod] = useState();
  const [lastDateTable, setLastDateTable] = useState();

  //состояние модалок, по дефолту скрыты
  let [show, toggleModalShow] = useState({
    deletePeriod: false,
    addPeriod: false,
    changePeriod: false,
  });
  //открытие/закрытие модалок
  const toggleShow = (modalName) => {
    toggleModalShow({ ...show, [modalName]: !show[modalName] });
  };

  const soloPricesTypes = ['333', '5186', '5187'];

  //установка цен в стейт
  useEffect(() => {
    //если тип цены "с человека", то добавляем тольк цены за 1 человека и цены доп.мест/детского
    let newPrices = {};
    let currentDates;
    if (formRef.current?.values) {
      currentDates = Object.keys(formRef.current?.values).map(
        (date) => date.split('|')[0]
      );
    }

    if (prices) {
      if (!soloPricesTypes.includes(priceType)) {
        newPrices = { ...prices };

        if (formRef.current?.values) {
          newPrices = Object.keys(prices).reduce((acc, cur) => {
            if (currentDates && currentDates.includes(cur)) {
              acc = { ...acc, [cur]: prices[cur] };
            }
            return acc;
          }, {});
        }

        setRoomPrice(newPrices);
        return;
      }

      Object.keys(prices).forEach((date) => {
        if (currentDates && !currentDates.includes(date)) {
          return;
        }

        let pricesPerPeople = prices[date].filter(
          (item) =>
            item.type == 1 || item.type == 'child' || item.type == 'additional'
        );

        if (!pricesPerPeople.find((item) => item.type == 1)) {
          newPrices = {
            ...newPrices,
            [date]: [{ type: 1, price: '' }, ...pricesPerPeople],
          };
        } else {
          newPrices = { ...newPrices, [date]: pricesPerPeople };
        }
      });

      setRoomPrice(newPrices);
    } else if (formRef.current && formRef.current.values) {
      let formValue = formRef.current.values;

      if (!soloPricesTypes.includes(priceType)) {
        newPrices = Object.keys(formValue).reduce((acc, cur, i, arr) => {
          let date = cur.split('|')[0];
          let type = cur.split('|')[1];

          if (!acc[date]) {
            acc = { ...acc, [date]: [] };
          }
          acc = {
            ...acc,
            [date]: [...acc[date], { type, price: formValue[cur] }],
          };

          return acc;
        }, {});

        setRoomPrice(newPrices);
        return;
      }

      newPrices = Object.keys(formValue).reduce((acc, cur, i, arr) => {
        let date = cur.split('|')[0];
        let type = cur.split('|')[1];

        if (!acc[date]) {
          acc = { ...acc, [date]: [] };
        }
        if (type == 1 || type == 'child' || type == 'additional') {
          acc = {
            ...acc,
            [date]: [...acc[date], { type, price: formValue[cur] }],
          };
        }

        return acc;
      }, {});

      setRoomPrice(newPrices);
    }
  }, [prices, priceType]);

  useEffect(() => {
    if (roomPrice) {
      //формируем массив всех типов размещения на корторые есть цены
      let allTypes = [];

      Object.values(roomPrice)
        .flat()
        .forEach((item) => {
          if (allTypes.indexOf(item.type) === -1) {
            allTypes.push(item.type);
          }
        });

      //установка начальных значений цен
      let initVal = {};
      Object.keys(roomPrice).map((date) => {
        allTypes.forEach((type) => {
          let filterPrice = roomPrice[date].filter((item) => item.type == type);
          initVal = {
            ...initVal,
            [`${date}|${type}`]: filterPrice[0]?.price
              ? filterPrice[0]?.price
              : '',
          };
        });
      });
      //установка последней даты последнего периода. Для того что-бы при добавлении нового периода, добавять сразу после последнего
      let lastDateTable = Object.keys(roomPrice).pop()?.split('/')[1];
      setLastDateTable(lastDateTable);

      setInitialValues(initVal);
    }
  }, [roomPrice, priceType]);

  //установка типов размещения
  useEffect(() => {
    let typeAllocation = [];
    initialValues &&
    Object.keys(initialValues).map((item) =>
      typeAllocation.push(item.split('|')[1])
    );

    let typeAllocationClean = new Set(typeAllocation);

    let numbersAllocations = [...typeAllocationClean].filter((type) =>
      Number(type)
    );
    let sortedTypeOfAllocations = numbersAllocations.sort((a, b) => b - a);

    if ([...typeAllocationClean].includes('child')) {
      sortedTypeOfAllocations.push('child');
    }
    if ([...typeAllocationClean].includes('additional')) {
      sortedTypeOfAllocations.push('additional');
    }

    setPersonesCountLine([...sortedTypeOfAllocations]);
  }, [initialValues, priceType]);

  //установка пунктов для выпадающих меню в шапке календанря
  useEffect(() => {
    if (personesCountLine) {
      let typeAllocationOver = [];

      if (!soloPricesTypes.includes(priceType)) {
        for (let i = 1; i <= maxType; i++) {
          if (personesCountLine && !personesCountLine.includes(String(i))) {
            typeAllocationOver.push(String(i));
          }
        }

        typeAllocationOver.reverse();
      }

      if (personesCountLine.indexOf('child') === -1) {
        typeAllocationOver.push('child');
      }
      if (personesCountLine.indexOf('additional') === -1) {
        typeAllocationOver.push('additional');
      }

      setPersonesCountLineOver(typeAllocationOver);
    }
  }, [personesCountLine, priceType]);

  //реф формы цен
  const formRef = useRef();
  //переназначенный submit формы
  const pricesSubmiteHandler = (values) => {
    if (formRef.current && formRef.current.values) {
      formRef.current.handleSubmit();
    }
  };

  const prevPriceType = usePrevious(priceType);
  useEffect(() => {
    if (priceType && prevPriceType && priceType !== prevPriceType) {
      pricesSubmiteHandler();
    }
  }, [priceType]);

  //добавление/удаление типа размещения
  const addTypeOfAllocation = (value, type, col) => {
    if (type === 'delete') {
      let newTypeOfAllocation = {};

      let filtredAllocation = Object.keys(value).filter(
        (date) => date.split('|')[1] !== col
      );
      filtredAllocation.forEach((date) => {
        newTypeOfAllocation = { ...newTypeOfAllocation, [date]: value[date] };
      });

      setInitialValues(newTypeOfAllocation);
      pricesSubmiteHandler();
    } else {
      let initVal = { ...value };
      Object.keys(roomPrice).forEach((date) => {
        initVal = { ...initVal, [`${date}|${col}`]: '' };
      });

      setInitialValues(initVal);
    }
  };

  //подтверждение удаления периода
  const deletePeriodConfirm = (period) => {
    setDeletedPeriod(period);
    toggleShow('deletePeriod');
  };

  //удаление периода
  const deletePeriod = () => {
    pricesSubmiteHandler();
    toggleUnsavedPage(true);
    toggleShow('deletePeriod');
    let newRoomPrice = { ...roomPrice };
    delete newRoomPrice[deletedPeriod];

    setRoomPrice(newRoomPrice);

    let presavePrice =
      newRoomPrice &&
      Object.keys(newRoomPrice).reduce((acc, cur, i, arr) => {
        newRoomPrice[cur].forEach((item) => {
          acc = { ...acc, [cur + `|` + item.type]: item.price };
        });
        return acc;
      }, {});

    presavedPrice({ [id]: presavePrice ? JSON.stringify(presavePrice) : null });
  };

  //добавление периода
  const addPeriod = (addPeriod, oldPrices, type) => {
    if (changedPeriod && changedPeriod === addPeriod.join('/')) {
      setChangedPeriod(null);
      return;
    }

    toggleUnsavedPage(true);
    //старая таблица цен
    let oldPriceTable = { ...roomPrice };
    Object.keys(oldPriceTable).forEach((date) => {
      oldPriceTable[date] = [];
    });

    //старый массив периодов (!без дублей)
    let filtredOldPeriods = [];

    //проходи циклом таблицу цен и добавляем уникальные периоды в старый массив периодов
    if (oldPrices) {
      Object.keys(oldPrices).forEach((period) => {
        if (filtredOldPeriods.indexOf(period.split('|')[0]) === -1) {
          filtredOldPeriods.push(period.split('|')[0]);
        }
      });
    }

    //объект с изменияемыми ценами
    let changedPrices = {};
    if (type === 'change') {
      filtredOldPeriods = filtredOldPeriods.filter(
        (oldPeriod) => oldPeriod != changedPeriod
      );

      let changedPeriodInTable = Object.keys(oldPrices).filter(
        (item) => item.split('|')[0] === changedPeriod
      );

      changedPrices = { [changedPeriod]: [] };
      changedPeriodInTable.forEach((periodAndType) => {
        changedPrices = {
          ...changedPrices,
          [changedPeriod]: [
            ...changedPrices[changedPeriod],
            {
              type: periodAndType.split('|')[1],
              price:
                oldPrices[changedPeriod + '|' + periodAndType.split('|')[1]],
            },
          ],
        };
      });

      changedPrices = Object.values(changedPrices)[0];
    }

    //получаем даты из нового периода
    let dateFrom = new Date(addPeriod[0])
      .toLocaleDateString('ru-RU')
      .split('.')
      .reverse()
      .join('-');
    let dateTo = new Date(addPeriod[1])
      .toLocaleDateString('ru-RU')
      .split('.')
      .reverse()
      .join('-');

    //массив всех дат с новым периодом (даты в секундах)
    let arrDatesFull = [];

    //переводим даты из нового периода в секунды
    let dateFromSec = new Date(dateFrom).getTime();
    let dateToSec = new Date(dateTo).getTime();

    //добавляем новые даты в массив всех дат
    arrDatesFull.push(dateFromSec, dateToSec);

    //перебираем все даты которые уже отрендерены
    filtredOldPeriods.forEach((date) => {
      //получаем даты из старого периода
      let datesFromOldString = date.split('|')[0].split('/')[0];
      let datesToOldString = date.split('|')[0].split('/')[1];

      //переводим даты из старого периода в секунды
      let datesFromOldSec = new Date(datesFromOldString).getTime();
      let datesToOldSec = new Date(datesToOldString).getTime();

      //состовляем старую таблицу цен
      Object.keys(oldPrices).forEach((item) => {
        if (item.split('|')[0] === date) {
          oldPriceTable = {
            ...oldPriceTable,
            [date]: [
              ...oldPriceTable[date],
              { type: item.split('|')[1], price: oldPrices[item] },
            ],
          };
        }
      });

      //если дата начала старого периода не содержится в добавляемом периоде то пушим ее в массив всех дат
      if (!(dateFromSec <= datesFromOldSec && datesFromOldSec <= dateToSec)) {
        arrDatesFull.push(datesFromOldSec);
      }

      //если дата окончания старого периода не содержится в добавляемом периоде то пушим ее в массив всех дат
      if (!(dateFromSec <= datesToOldSec && datesToOldSec <= dateToSec)) {
        arrDatesFull.push(datesToOldSec);
      }
    });

    //сортируем массив всех дат по возрастанию
    arrDatesFull = [...arrDatesFull].sort((a, b) => a - b);

    //получаем индексы дат начала и конца нового периода в массиве всех дат
    let indexFrom = arrDatesFull.indexOf(dateFromSec);
    let indexTo = arrDatesFull.indexOf(dateToSec);

    //определяем дату которая будет добавляться до даты "начала периода" при делении старых периодов
    let newDateFrom = new Date(dateFrom);
    newDateFrom = newDateFrom.setDate(newDateFrom.getDate() - 1);
    let oldDateFrom = new Date(dateFrom).getTime();

    //определяем дату которая будет добавляться после даты "конца периода" при делении старых периодов
    let newDateTo = new Date(dateTo);
    newDateTo = newDateTo.setDate(newDateTo.getDate() + 1);
    let oldDateTo = new Date(dateTo).getTime();

    //если массив дат четный, то возможные варианты:
    // 1) добавление нового периода без пересечений,
    // 2) добавление нового периода внутрь старого,
    // 3) поглощение новым периодом одного из старых
    // 4) новый период забирает часть от 2, 4 и т.д периодов (четное количество периодов)
    if (arrDatesFull.length % 2 === 0) {
      if (!(indexTo - indexFrom === 1 && indexFrom % 2 === 0)) {
        arrDatesFull.push(newDateTo, newDateFrom);
      }
    } else {
      //если массив дат нечетный, то возможные варианты
      //1) добавление нового периода с пересечением с одним из старых
      if (indexFrom % 2 === 0) {
        //условие выполняется если в новый период попадает часть старого периода с датой до
        if (oldDateTo !== newDateTo) {
          arrDatesFull.push(newDateTo);
        }
      } else {
        //условие выполняется если в новый период попадает часть старого периода с датой от
        if (newDateFrom !== oldDateFrom) {
          arrDatesFull.push(newDateFrom);
        }
      }
    }

    //сортируем массив всех дат по возрастанию
    arrDatesFull = [...arrDatesFull].sort((a, b) => a - b);

    //переводим все даты в изначальный вид
    arrDatesFull = arrDatesFull.map((item) => {
      return new Date(item)
        .toLocaleDateString('ru-RU')
        .split('.')
        .reverse()
        .join('-');
    });

    //склеиваем новый массив периодов (без цен)
    let newArrPeriods = chunk(arrDatesFull, 2).map((period) => {
      return period.join('/');
    });

    //составляем новую таблицу цен
    let newRoomPrices = {};

    //перебор новых периодов
    newArrPeriods.forEach((period) => {
      //если текущего нового периода нет в старой таблице цен то
      if (!oldPriceTable.hasOwnProperty(period)) {
        //проверяем является ли новый период частью одного из старых (по дефолту нет)
        let newPeriodWithinOld = null;
        Object.keys(oldPriceTable).forEach((oldPeriod) => {
          let oldFromDate = new Date(oldPeriod.split('/')[0]);
          let oldToDate = new Date(oldPeriod.split('/')[1]);
          let newFromDate = new Date(period.split('/')[0]);
          let newToDate = new Date(period.split('/')[1]);
          if (
            isWithinInterval(newFromDate, {
              start: oldFromDate,
              end: oldToDate,
            }) &&
            isWithinInterval(newToDate, { start: oldFromDate, end: oldToDate })
          ) {
            newPeriodWithinOld = oldPeriod;
          }
        });

        //если новый период не входит в рамки одного из старых периодов
        if (!newPeriodWithinOld) {
          //в новой таблице цен создаем новое свойство
          newRoomPrices = { ...newRoomPrices, [period]: '' };

          //проверяем если ли в уже добавленные типы размещения
          if (personesCountLine && personesCountLine.length !== 0) {
            //если изменяем период, то в новый период записываем цены изменяемого
            if (type === 'change') {
              newRoomPrices = { ...newRoomPrices, [period]: changedPrices };
            } else {
              //добавляем период и если типы размещения уже есть, записываем новые цены в имеющиеся типы размещения
              personesCountLine.forEach((personPrice) => {
                newRoomPrices = {
                  ...newRoomPrices,
                  [period]: [
                    ...newRoomPrices[period],
                    { type: personPrice, price: '' },
                  ],
                };
              });
            }
          } else {
            //если типов размещения нет, то берем максимальный тип размещения из пропсов и устанавливаем ему цену
            newRoomPrices = {
              ...newRoomPrices,
              [period]: [
                ...newRoomPrices[period],
                { type: maxType, price: '' },
              ],
            };
          }
        } else {
          //если новый период полностью входит в рамки одного из старых периодов, то устанавливаем ему цену старого периода
          newRoomPrices = {
            ...newRoomPrices,
            [period]: roomPrice[newPeriodWithinOld],
          };
        }
      } else {
        //если текущий новый период есть в старой таблицен, то добавляем в новую таблицу значения по ключю из старой
        newRoomPrices = {
          ...newRoomPrices,
          [period]: [...oldPriceTable[period]],
        };
      }
    });

    //сортируем периоды по возрастанию
    let sortingDates = Object.keys(newRoomPrices).sort(
      (a, b) =>
        new Date(a.split('/')[0]).getTime() -
        new Date(b.split('/')[0]).getTime()
    );

    //собираем отсортированные периоды
    let newRoomPricesSorting = {};
    sortingDates.forEach((date) => {
      newRoomPricesSorting = {
        ...newRoomPricesSorting,
        [date]: newRoomPrices[date],
      };
    });

    const presavePrice = Object.keys(newRoomPricesSorting).reduce(
      (acc, cur) => {
        newRoomPricesSorting[cur].forEach((price) => {
          acc = { ...acc, [`${cur}|${price.type}`]: price.price };
        });
        return acc;
      },
      {}
    );

    //делаем предсохраннение цен
    presavedPrice({ [id]: { prices: presavePrice, priceType: priceType } });

    //сетаем новые цены в стейт
    setRoomPrice(newRoomPricesSorting);
    setChangedPeriod(null);
    toggleShow('addPeriod');
  };

  //изменение периода(открытие модалки с выбором дат)
  const changePeriodConfirm = (period) => {
    setChangedPeriod(period);
    toggleShow('changePeriod');
  };

  //изменение периода(открытие модалки с выбором дат)
  const changePeriod = (period, oldPrices) => {
    addPeriod(period, oldPrices, 'change');
    toggleShow('changePeriod');
  };

  const changeFormDirty = () => {
    goBackToInitialState(id);
  };

  //сохранение цен номера
  const onSubmite = (values) => {
    toggleUnsavedPage(true);

    presavedPrice({ [id]: { prices: values, priceType: priceType } });
  };

  const buttons = themeButtons();

  return (
    <Formik
      enableReinitialize
      innerRef={formRef}
      initialValues={initialValues}
      onSubmit={onSubmite}
    >
      {({ values }) => {
        return (
          <Form>
            <ChangeDirtyForm changeDirtyAction={changeFormDirty}/>
            <div className='room-calendar__table'>
              {roomPrice && personesCountLine && personesCountLine.length > 0 && (
                <div className='room-calendar__row'>
                  <RenderPeriodTableHeader
                    personesCountLine={personesCountLine}
                    personesCountLineOver={personesCountLineOver}
                    addTypeOfAllocation={addTypeOfAllocation}
                  />
                </div>
              )}

              {roomPrice &&
                Object.keys(roomPrice)
                  .sort(
                    (a, b) =>
                      new Date(a.split('/')[0]).getTime() -
                      new Date(b.split('/')[0]).getTime()
                  )
                  .map((date) => {
                    return (
                      <RenderPeriodTableRow
                        key={date}
                        date={date}
                        dateFrom={date
                          .split('/')[0]
                          .split('-')
                          .reverse()
                          .join('.')
                          .slice(0, 5)}
                        dateTo={date
                          .split('/')[1]
                          .split('-')
                          .reverse()
                          .join('.')
                          .slice(0, 5)}
                        personesCountLine={personesCountLine}
                        personesCountLineOver={personesCountLineOver}
                        addTypeOfAllocation={addTypeOfAllocation}
                        deletePeriodConfirm={deletePeriodConfirm}
                        changePeriod={changePeriodConfirm}
                      />
                    );
                  })}

              <AutoSaveWithDebounce debounceMs={100}/>
            </div>

            {show.deletePeriod && (
              <ModalDeletePeriod
                toggleShow={() => toggleShow('deletePeriod')}
                show={show.deletePeriod}
                period={deletedPeriod}
                action={deletePeriod}
              />
            )}
            {show.addPeriod && (
              <ModalAddPeriod
                toggleShow={() => toggleShow('addPeriod')}
                show={show.addPeriod}
                period={deletedPeriod}
                lastDateTable={lastDateTable}
                action={addPeriod}
              />
            )}
            {show.changePeriod && (
              <ModalChangePeriod
                toggleShow={() => toggleShow('changePeriod')}
                show={show.changePeriod}
                changedPeriod={changedPeriod}
                action={changePeriod}
              />
            )}

            <div
              className='room-calendar__table-footer'
              style={{ borderTop: '1px solid #ebebeb' }}
            >
              <div className='add-period-btn'>
                <Button
                  onClick={() => toggleShow('addPeriod')}
                  className={`btn ${buttons.btnLight}`}
                >
                  Добавить период
                </Button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
});

//основной компонент календаря
const CalendarSubscription = React.memo((props) => {
  const {
    getPrices,
    objectId,
    calendar,
    savePrices,
    updaterPriceType,
    getPriceTypes,
    priceTypes,
  } = props;

  const [pricesRooms, setPricesRooms] = useState({});
  const [unsavedPage, toggleUnsavedPage] = useState(false);
  const [targetRedirectLink, setTargetRedirectLink] = useState(false);
  const history = useHistory();

  //состояние и контроль аккордиона
  const [expanded, setExpanded] = useState();
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  //запрос на получение цен и типов цены
  useEffect(() => {
    if (objectId) {
      getPrices(objectId);
    }
    if (!priceTypes) {
      getPriceTypes();
    }
  }, []);

  //установка активной панели аккордиона
  const prevExpanded = usePrevious(expanded);
  useEffect(() => {
    if (calendar && prevExpanded != props.match.params.roomId) {
      setExpanded(props.match.params.roomId);
    }
  }, []);

  const presavedPrice = (priceRoom) => {
    setPricesRooms({ ...pricesRooms, ...priceRoom });
  };

  //сохранение страницы
  const savePage = async (values) => {
    toggleUnsavedPage(false);

    let response = await savePrices({
      object: objectId,
      rooms: JSON.stringify(pricesRooms),
    });

    if (response) {
      if (targetRedirectLink) {
        history.push(targetRedirectLink);
      }
    }
  };

  const goBackToInitialState = (roomId) => {
    let pricesRoomsCopy = { ...pricesRooms };
    delete pricesRoomsCopy[roomId];

    if (Object.keys(pricesRoomsCopy).length === 0) {
      toggleUnsavedPage(false);
    }
  };
  const updatePriceType = (room, values) => {
    toggleUnsavedPage(true);
    updaterPriceType(room, values.priceType);
    setExpanded(room);
  };

  if (Object.keys(calendar).length === 0) {
    return <Preloader loading={true} text={'Загружаем цены'}/>;
  }
  return (
    <>
      <RenderSettingsMenu/>
      <div className='container-fluid'>
        <div id='rooms-calendar'>
          {Object.keys(calendar).map((room) => {
            return (
              <AccordionStyled
                key={room}
                expanded={expanded === room}
                className='room-calendar'
                onChange={handleChange(room)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon/>}
                  aria-controls='panel1bh-content'
                  id='panel1bh-header'
                >
                  <div className='room-calendar__header '>
                    <h5 className='m-2 ms-0'>{calendar[room].name}</h5>

                    {expanded === room && (
                      <Formik
                        enableReinitialize
                        initialValues={{
                          priceType: calendar[room].priceType
                            ? calendar[room].priceType
                            : '334',
                        }}
                        onSubmit={(values) => updatePriceType(room, values)}
                      >
                        {({ values }) => (
                          <Form>
                            <Field name='priceType'>
                              {({ field }) => {
                                return (
                                  <FormControl
                                    variant='outlined'
                                    size='small'
                                    onClick={(event) => event.stopPropagation()}
                                    onFocus={(event) => event.stopPropagation()}
                                  >
                                    <InputLabel>Тип цены</InputLabel>

                                    <Select {...field} label='Тип цены'>
                                      {priceTypes &&
                                        Object.keys(priceTypes).map((id) => (
                                          <MenuItem key={id} value={`${id}`}>
                                            {priceTypes[id]}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                  </FormControl>
                                );
                              }}
                            </Field>
                            <AutoSaveWithDebounce debounceMs={10}/>
                          </Form>
                        )}
                      </Formik>
                    )}
                  </div>

                  <div className='room-calendar__header-btn-text'>
                    Посмотреть/Редактировать
                  </div>
                </AccordionSummary>

                <AccordionDetailStyled>
                  <RenderPriceTableSubscriber
                    {...calendar[room]}
                    presavedPrice={presavedPrice}
                    goBackToInitialState={goBackToInitialState}
                    toggleUnsavedPage={toggleUnsavedPage}
                  />
                </AccordionDetailStyled>
              </AccordionStyled>
            );
          })}
        </div>

        {unsavedPage && <StickyBottomButton action={savePage}/>}
        <AlertSavePage
          unsavedPage={unsavedPage}
          btnOkAction={savePage}
          setTargetRedirectLink={setTargetRedirectLink}
          targetRedirectLink={targetRedirectLink}
        />
      </div>
    </>
  );
});

export default CalendarSubscription;
